import { Route, Routes } from "react-router-dom";
import Card from "./Card";
import CardList from "./CardList";

export default function Cards() {
	return (
		<Routes>
			<Route path=":id" element={<Card />} />
			<Route path="/" element={<CardList />} />
		</Routes>
	);
}